<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Job Issue'"
      [canGoBack]="true"
      [customBack]="'job-issue'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


    <tidy-card>
      <tidy-row [align]="'center'" class="extra-bottom-padding">
        <tidy-text
          [body]="'This job on'" /><span>&nbsp;</span>
          <tidy-text
          [body]="(job?.job?.date | parseDateTime: 'ddd') + ' ' + (job?.job?.date | parseDateTime: 'MMM d')" /><span>&nbsp;</span>
            <tidy-text
              [body]="'at'" /><span>&nbsp;</span>
              <tidy-text
                [body]="job?.job?.start_time | parseDateTime: 'h:mma'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="'is marked as'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="jobStatus" />
                  <tidy-text
                    [body]="'. What is your issue?'" />
                </tidy-row>
                <tidy-card-button (action)="selectIssue('bad_quality')">
                  <tidy-row>
                    <tidy-text
                      [body]="'The service quality was bad'" />
                  </tidy-row>
                </tidy-card-button>
                <tidy-card-button (action)="selectIssue('no_show')">
                  <tidy-row>
                    <tidy-text
                      [body]="'The pro never showed up'" />
                  </tidy-row>
                </tidy-card-button>
                <tidy-card-button (action)="selectIssue('damage_claim')">
                  <tidy-row>
                    <tidy-text
                      [body]="'Something is damaged'" />
                  </tidy-row>
                </tidy-card-button>
                <tidy-card-button (action)="selectIssue('tip')">
                  <tidy-row>
                    <tidy-text
                      [body]="'I want to leave a tip'" />
                  </tidy-row>
                </tidy-card-button>
                <tidy-card-button (action)="selectIssue('other_issue')">
                  <tidy-row>
                    <tidy-text
                      [body]="'Other service issue (slowest)'" />
                  </tidy-row>
                </tidy-card-button>
              </tidy-card>

            </tidy-wrapper>
          </ng-template>

          @if (!isRightSideContent) {
            <app-scroll-wrapper [templateContent]="content" />
          }

          @if (isRightSideContent) {
            <ion-content class="ion-content-right-column">
              <ng-container *ngTemplateOutlet="content" />
            </ion-content>
          }
